import React from 'react'
import autoBind from 'react-autobind'
import TextField from 'material-ui/TextField'
import SelectField from 'material-ui/SelectField'
import MenuItem from 'material-ui/MenuItem'
import _ from 'lodash'

class PreviewData extends React.Component {
  constructor(props) {
    super(props)
    
    autoBind(this)
  }
  render() {
    const { styles, dropzoneStyles, product, handlePreviewDataChange, handleUploadedImage, client, handleProductOptionSelect, items } = this.props
    return (
      <div>
        <h2>Preview Data</h2>
        <div className="content">
          <div>
            <SelectField
              onChange={(event, index, value) => handleProductOptionSelect(event, index, value)}
              floatingLabelText="Copy Settings From:"
              name="productItem"
              floatingLabelStyle={styles.floatingLabelStyle}
            >
              {items && items.map((productItem, i) =>{
                return <MenuItem  key={i} value={productItem} primaryText={productItem.name} />
              })}
            </SelectField>
          </div>
          <br />
          {product.preview.portrait.map((portrait, index) => {
            return (
              <div>
                <h3 style={{ fontSize: '18px' }}>Vertical Settings</h3>
                <TextField
                  floatingLabelText="Vertical Background Image Url"
                  floatingLabelStyle={styles.floatingLabelStyle}
                  floatingLabelFixed={true}
                  value={portrait.img}
                  name={`portrait[${index}].img`}
                  style={styles.inputStyleURL}
                />
                <button
                  className="filestack-button"
                  onClick={(e) => {
                    e.preventDefault;
                    return client.picker({
                      uploadInBackground: false,
                      onUploadDone: ((res) => {
                        console.log('RES FROM FILESTACK', res);
                        const targetName = `portrait[${index}]img`
                        const targetValue = res.filesUploaded[0].url
                        handleUploadedImage(targetName, targetValue)
                      })
                    }).open()
                  }}
                  style={dropzoneStyles}>
                  <p className="filestack-uplaod">Upload Vertical Background Image</p>
                </button>
                <br />
                <TextField
                  floatingLabelText="Vertical Preview Img X Position"
                  floatingLabelStyle={styles.floatingLabelStyle}
                  floatingLabelFixed={true}
                  value={portrait.x}
                  onChange={handlePreviewDataChange}
                  name={`portrait[${index}].x`}
                  style={styles.inputStyle}
                />
                <TextField
                  floatingLabelText="Vertical Preview Img Y Position"
                  floatingLabelStyle={styles.floatingLabelStyle}
                  floatingLabelFixed={true}
                  value={portrait.y}
                  onChange={handlePreviewDataChange}
                  name={`portrait[${index}].y`}
                  style={styles.inputStyle}
                />
                <TextField
                  floatingLabelText="Vertical Preview Img Z Position"
                  floatingLabelStyle={styles.floatingLabelStyle}
                  floatingLabelFixed={true}
                  value={portrait.z}
                  onChange={handlePreviewDataChange}
                  name={`portrait[${index}].z`}
                  style={styles.inputStyle}
                />
                <TextField
                  floatingLabelText="Vertical Preview Img Width"
                  floatingLabelStyle={styles.floatingLabelStyle}
                  floatingLabelFixed={true}
                  value={portrait.width}
                  onChange={handlePreviewDataChange}
                  name={`portrait[${index}].width`}
                  style={styles.inputStyle}
                />
                <TextField
                  floatingLabelText="Vertical Preview Img Height"
                  floatingLabelStyle={styles.floatingLabelStyle}
                  floatingLabelFixed={true}
                  value={portrait.height}
                  onChange={handlePreviewDataChange}
                  name={`portrait[${index}].height`}
                  style={styles.inputStyle}
                />
                <TextField
                  floatingLabelText="Vertical Preview Img Angle"
                  floatingLabelStyle={styles.floatingLabelStyle}
                  floatingLabelFixed={true}
                  value={portrait.angle || 0}
                  onChange={handlePreviewDataChange}
                  name={`portrait[${index}].angle`}
                  style={styles.inputStyle}
                />
                <TextField
                  floatingLabelText="Zoomed Overlay"
                  floatingLabelStyle={styles.floatingLabelStyle}
                  floatingLabelFixed={true}
                  value={portrait.zoomedOverlay || 0}
                  onChange={handlePreviewDataChange}
                  name={`portrait[${index}].zoomedOverlay`}
                  style={styles.inputStyle}
                />
                <TextField
                  floatingLabelText="Zoomed X"
                  floatingLabelStyle={styles.floatingLabelStyle}
                  floatingLabelFixed={true}
                  value={portrait.zoomedX || 0}
                  onChange={handlePreviewDataChange}
                  name={`portrait[${index}].zoomedX`}
                  style={styles.inputStyle}
                />
                <TextField
                  floatingLabelText="Zoomed Y"
                  floatingLabelStyle={styles.floatingLabelStyle}
                  floatingLabelFixed={true}
                  value={portrait.zoomedY || 0}
                  onChange={handlePreviewDataChange}
                  name={`portrait[${index}].zoomedY`}
                  style={styles.inputStyle}
                />
                <TextField
                  floatingLabelText="Zoomed Width"
                  floatingLabelStyle={styles.floatingLabelStyle}
                  floatingLabelFixed={true}
                  value={portrait.zoomedWidth || 0}
                  onChange={handlePreviewDataChange}
                  name={`portrait[${index}].zoomedWidth`}
                  style={styles.inputStyle}
                />
                <TextField
                  floatingLabelText="Zoomed Height"
                  floatingLabelStyle={styles.floatingLabelStyle}
                  floatingLabelFixed={true}
                  value={portrait.zoomedHeight || 0}
                  onChange={handlePreviewDataChange}
                  name={`portrait[${index}].zoomedHeight`}
                  style={styles.inputStyle}
                />
                <br />
                <div style={{ position: 'relative', width: '870px', height: '607px' }}>
                  <img style={{ width: '870px', height: '607px', verticalAlign: 'middle', border: '0px', position: 'relative' }}
                    src={portrait.img} />
                  <div style={{
                    width: `${portrait.width}px`,
                    height: `${portrait.height}px`,
                    position: 'absolute',
                    verticalAlign: 'middle',
                    zIndex: 5,
                    top: `${portrait.y}px`,
                    left: `${portrait.x}px`,
                    border: '1px solid #0062cc',
                    backgroundColor: 'rgba(0, 98, 204, .28)'
                  }}>
                  </div>
                </div>
                <br />
                <br />
              </div>
            )
          })}
          {product.preview.landscape.map((landscape, index) => {
            return (
              <div>
                <h3 style={{ fontSize: '18px' }}>Horizontal Settings</h3>
                <TextField
                  floatingLabelText="Horizontal Background Image Url"
                  floatingLabelStyle={styles.floatingLabelStyle}
                  floatingLabelFixed={true}
                  value={landscape.img}
                  name={`landscape[${index}].img`}
                  style={styles.inputStyleURL}
                />
                <button
                  className="filestack-button"
                  onClick={(e) => {
                    e.preventDefault;
                    return client.picker({
                      uploadInBackground: false,
                      onUploadDone: ((res) => {
                        console.log('RES FROM FILESTACK', res);
                        const targetName = `landscape[${index}]img`
                        const targetValue = res.filesUploaded[0].url
                        handleUploadedImage(targetName, targetValue)
                      })
                    }).open()
                  }}
                  style={dropzoneStyles}>
                  <p className="filestack-uplaod">Upload Horizontal Background Image</p>
                </button>
                <br />
                <TextField
                  floatingLabelText="Horizontal Preview Img X Position"
                  floatingLabelStyle={styles.floatingLabelStyle}
                  floatingLabelFixed={true}
                  value={landscape.x}
                  onChange={handlePreviewDataChange}
                  name={`landscape[${index}].x`}
                  style={styles.inputStyle}
                />
                <TextField
                  floatingLabelText="Horizontal Preview Img Y Position"
                  floatingLabelStyle={styles.floatingLabelStyle}
                  floatingLabelFixed={true}
                  value={landscape.y}
                  onChange={handlePreviewDataChange}
                  name={`landscape[${index}].y`}
                  style={styles.inputStyle}
                />
                <TextField
                  floatingLabelText="Horizontal Preview Img Z Position"
                  floatingLabelStyle={styles.floatingLabelStyle}
                  floatingLabelFixed={true}
                  value={landscape.z}
                  onChange={handlePreviewDataChange}
                  name={`landscape[${index}].z`}
                  style={styles.inputStyle}
                />
                <TextField
                  floatingLabelText="Horizontal Preview Img Width"
                  floatingLabelStyle={styles.floatingLabelStyle}
                  floatingLabelFixed={true}
                  value={landscape.width}
                  onChange={handlePreviewDataChange}
                  name={`landscape[${index}].width`}
                  style={styles.inputStyle}
                />
                <TextField
                  floatingLabelText="Horizontal Preview Img Height"
                  floatingLabelStyle={styles.floatingLabelStyle}
                  floatingLabelFixed={true}
                  value={landscape.height}
                  onChange={handlePreviewDataChange}
                  name={`landscape[${index}].height`}
                  style={styles.inputStyle}
                />
                <TextField
                  floatingLabelText="Horizontal Preview Img Angle"
                  floatingLabelStyle={styles.floatingLabelStyle}
                  floatingLabelFixed={true}
                  value={landscape.angle || 0}
                  onChange={handlePreviewDataChange}
                  name={`landscape[${index}].angle`}
                  style={styles.inputStyle}
                />
                <TextField
                  floatingLabelText="Zoomed Overlay"
                  floatingLabelStyle={styles.floatingLabelStyle}
                  floatingLabelFixed={true}
                  value={landscape.zoomedOverlay == null ? '' : landscape.zoomedOverlay}
                  onChange={handlePreviewDataChange}
                  name={`landscape[${index}].zoomedOverlay`}
                  style={styles.inputStyle}
                />
                <TextField
                  floatingLabelText="Zoomed X"
                  floatingLabelStyle={styles.floatingLabelStyle}
                  floatingLabelFixed={true}
                  value={landscape.zoomedX == null ? 0 : landscape.zoomedY}
                  onChange={handlePreviewDataChange}
                  name={`landscape[${index}].zoomedX`}
                  style={styles.inputStyle}
                />
                <TextField
                  floatingLabelText="Zoomed Y"
                  floatingLabelStyle={styles.floatingLabelStyle}
                  floatingLabelFixed={true}
                  value={landscape.zoomedY == null ? 0 : landscape.zoomedY}
                  onChange={handlePreviewDataChange}
                  name={`landscape[${index}].zoomedY`}
                  style={styles.inputStyle}
                />
                <TextField
                  floatingLabelText="Zoomed Width"
                  floatingLabelStyle={styles.floatingLabelStyle}
                  floatingLabelFixed={true}
                  value={landscape.zoomedWidth == null ? 0 : landscape.zoomedWidth}
                  onChange={handlePreviewDataChange}
                  name={`landscape[${index}].zoomedWidth`}
                  style={styles.inputStyle}
                />
                <TextField
                  floatingLabelText="Zoomed Height"
                  floatingLabelStyle={styles.floatingLabelStyle}
                  floatingLabelFixed={true}
                  value={landscape.zoomedHeight == null ? 0 : landscape.zoomedHeight}
                  onChange={handlePreviewDataChange}
                  name={`landscape[${index}].zoomedHeight`}
                  style={styles.inputStyle}
                />
                <br />
                <div style={{ position: 'relative', width: '870px', height: '607px' }}>
                  <img style={{ width: '870px', height: '607px', verticalAlign: 'middle', border: '0px', position: 'relative' }}
                    src={landscape.img} />
                  <div style={{
                    width: `${landscape.width}px`,
                    height: `${landscape.height}px`,
                    position: 'absolute',
                    verticalAlign: 'middle',
                    zIndex: 5,
                    top: `${landscape.y}px`,
                    left: `${landscape.x}px`,
                    border: '1px solid #0062cc',
                    backgroundColor: 'rgba(0, 98, 204, .28)'
                  }}>
                  </div>
                </div>
                <br />
                <br />
              </div>
            )
          })}
        </div>
      </div>
    )
  }
}

export default PreviewData;


// WEBPACK FOOTER //
// ./src/components/products/Common/PreviewData.js